/* eslint-disable import/prefer-default-export */
export const copywriting = {
  heading: "Explore organisation",
  navigateUp: "Go back up a level",
};
